<template>
  <div class="enter">
    <div v-show="popupFlag" class="popup-c">
      <div class="center popup">
        <div class="header">
          <div class="title">修改信息</div>
          <div class="close" @click="closePopup()">X</div>
        </div>
        <div class="main">
          <div v-show="popupType == '1'" class="edit-img">
            <p>
              1.图片需为jpg、jpeg、png格式
              <br />尺寸>500*500像素
            </p>
            <p>2.修改头像需经过审核，1个月只能修改1次</p>
            <div>
              <img :src="editHeadImg" alt />
            </div>
          </div>
          <div class="bottom">
            <div v-show="popupType != 1" class="left" @click="closePopup()">
              取消
            </div>
            <div v-show="popupType == 1" class="left" @click="autoClick()">
              更改图片
            </div>
            <input
              style="display: none"
              type="file"
              name
              id="headUpload"
              accept=".jpg, .png, .jpeg"
            />
            <div class="right" @click="edit(popupType)">确定</div>
          </div>
        </div>
      </div>
    </div>
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog
      title="图片剪裁"
      :visible.sync="cropper"
      append-to-body
      @close="clearHeadInput"
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <div style="width: auto; height: 500px">
            <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="option.info"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :autoCrop="option.autoCrop"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :fixedBox="option.fixedBox"
            ></vueCropper>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cropper = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <div class="layout-left">
      <div class="title">欢迎入驻酷狗音乐人Remix</div>
      <div class="tip">第1/2步·输入您的个性音乐人信息</div>
      <div class="row">
        <div class="left">
          <div class="label center-y">歌手名</div>
        </div>
        <div class="right">
          <input
            :class="`text ${claimFlag ? 'input-disabled' : ''}`"
            v-model="authorName"
            @keyup="singerSearch()"
            :disabled="claimFlag"
            maxlength="60"
            @blur="checkName"
            placeholder="请输入歌手名，最多60字符"
          />
        </div>
      </div>
      <div class="row" style="height: 90px">
        <div class="left">
          <div class="label center-y">头像</div>
        </div>
        <div
          class="right"
          style="width: 470px; background-color: rgba(239, 240, 245, 0.3)"
        >
          <div class="head-img">
            <img :src="avatar" alt srcset />
            <p>图片需为jpg、jpeg、png格式尺寸 > 500*500</p>
            <div class="btn" @click="autoClick">上传图片</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="left">
          <div class="label center-y">性别</div>
        </div>
        <div class="right">
          <div class="radio">
            <el-radio
              v-for="(item, i) in typeArr"
              :key="i"
              v-model="type"
              :label="item.type"
              >{{ item.typeStr }}</el-radio
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="left">
          <div class="label center-y">地区</div>
        </div>
        <div class="right">
          <el-select v-model="area" placeholder="请选择">
            <el-option
              v-for="item in areaArr"
              :key="item.type"
              :label="item.typeStr"
              :value="item.type"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="left">
          <div class="label center-y">身份</div>
        </div>
        <div class="right">
          <el-select v-model="identity" placeholder="请选择">
            <el-option
              v-for="item in identityArr"
              :key="item.type"
              :label="item.typeStr"
              :value="item.type"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="left">
          <div class="label center-y">流派</div>
        </div>
        <div class="right">
          <el-select v-model="style" placeholder="请选择">
            <el-option
              v-for="item in styleArr"
              :key="item.type"
              :label="item.typeStr"
              :value="item.type"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row" style="height: 160px">
        <div class="left">
          <div class="label center-y">简介</div>
        </div>
        <div class="right">
          <div class="textarea">
            <el-input
              type="textarea"
              :rows="6"
              :placeholder="introPlaceholder"
              resize="none"
              v-model="intro"
              @blur="checkIntro"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="row" style="height: 40px">
        <div class="left">
          <div class="label center-y">授权平台</div>
        </div>
        <div class="right">
          <img
            class="center-y"
            src="../assets/img/logo.png"
            alt
            srcset
            style="width: 80px"
          />
        </div>
      </div>

      <div class="tip" style="margin-top: 40px">
        第2/2步·提交实名信息完成认证
      </div>
      <div class="row">
        <div class="left">
          <div class="label center-y">身份证号码</div>
        </div>
        <div class="right">
          <input
            class="text"
            v-model="idcard"
            @blur="checkIdcard"
            placeholder="请输入身份证号码，审核通过后不可更改"
          />
        </div>
      </div>
      <div class="row">
        <div class="left">
          <div class="label center-y">真实姓名</div>
        </div>
        <div class="right">
          <input
            class="text"
            v-model="realName"
            @blur="checkNull('realName', '请输入真实姓名')"
            placeholder="请输入真实姓名，审核通过后不可更改"
          />
        </div>
      </div>
      <div class="row">
        <div class="left">
          <div class="label center-y">国籍</div>
        </div>
        <div class="right">
          <el-select v-model="country" placeholder="请选择">
            <el-option
              v-for="item in countryArr.filter((item) => item.type == 1)"
              :key="item.type"
              :label="item.typeStr"
              :value="item.type"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="left">
          <div class="label center-y">手机号</div>
        </div>
        <div class="right">
          <input
            :class="`text ${id ? 'input-disabled' : ''}`"
            :disabled="id != 0"
            v-model="mobile"
            @blur="checkNull('mobile', '请输入手机号')"
            placeholder="请输入手机号"
          />
        </div>
      </div>
      <div class="row" v-show="!id">
        <div class="left">
          <div class="label center-y">验证码</div>
        </div>
        <div class="right">
          <input
            class="text"
            style="width: 320px"
            v-model="code"
            @blur="checkNull('code', '请输入验证码')"
          />
          <div class="code-btn" v-show="!codeFlag" @click="sendCode()">
            发送验证码
          </div>
          <div class="code-time" v-show="codeFlag">{{ codeCount }}</div>
        </div>
      </div>
      <div class="row" style="width: 799px; height: 220px">
        <div class="left">
          <div class="label center-y">上传身份<br />证明</div>
        </div>
        <div class="right" style="width: 642px">
          <div class="upload-idcard">
            <div class="cover_item">
              <div class="cover_item_content">
                <img
                  v-show="idCardPic['1'].base64"
                  :src="idCardPic['1'].base64"
                  alt
                  srcset
                />
                <i v-show="!idCardPic['1'].base64" class="icon icon_id"></i>
                <p v-show="!idCardPic['1'].base64">身份证正面</p>
              </div>
              <input
                type="file"
                name
                value
                accept="image/jpeg, image/png, image/gif, image/bmp"
                @change="fileChange($event, 1)"
              />
              <a href="javascript:;" class="blue_btn">上传照片</a>
            </div>
            <div class="cover_item">
              <div class="cover_item_content">
                <img
                  v-show="idCardPic['2'].base64"
                  :src="idCardPic['2'].base64"
                  alt
                  srcset
                />
                <i
                  v-show="!idCardPic['2'].base64"
                  class="icon icon_id_back"
                ></i>
                <p v-show="!idCardPic['2'].base64">身份证反面</p>
              </div>
              <input
                type="file"
                name
                id
                value
                accept="image/jpeg, image/png, image/gif, image/bmp"
                @change="fileChange($event, 2)"
              />
              <a href="javascript:;" class="blue_btn">上传照片</a>
            </div>
            <div class="cover_item">
              <div class="cover_item_content">
                <img
                  v-show="idCardPic['3'].base64"
                  :src="idCardPic['3'].base64"
                  alt
                  srcset
                />
                <i
                  v-show="!idCardPic['3'].base64"
                  class="icon icon_id_handle"
                ></i>
                <p v-show="!idCardPic['3'].base64">手持身份证（半身+正面）</p>
              </div>
              <input
                type="file"
                name
                id
                value
                accept="image/jpeg, image/png, image/gif, image/bmp"
                @change="fileChange($event, 3)"
              />
              <a href="javascript:;" class="blue_btn">上传照片</a>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="width: 799px">
        <div class="left">
          <div class="label center-y"></div>
        </div>
        <div class="right">
          <div class="tip">
            <p>1.根据国家相关规定，请提供有效身份的彩色照片/彩色扫描件</p>
            <p>2.图片需为jpg、jpeg、png格式，且大小&lt;10M</p>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 30px" v-show="claimFlag">
        <div class="left">
          <div class="label center-y">上传站外<br />截图</div>
        </div>
        <div class="right">
          <div class="btn submit">上传图片</div>
          <input
            class="screen-upload"
            type="file"
            name
            value
            accept="image/jpeg, image/png, image/gif, image/bmp"
            multiple
            @click="checkNum"
            @change="screenUpload($event)"
          />
          <div class="screen-c">
            <div v-for="(item, i) in screenShot" :key="i" class="img-c">
              <img :src="item" alt="" srcset="" />
              <span class="img-del" @click="screenDel(i)">x</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="width: 799px" v-show="claimFlag">
        <div class="left">
          <div class="label center-y"></div>
        </div>
        <div class="right">
          <div class="tip">
            <p>
              1.如你已入驻其他音乐平台，上传该平台的个人主页截图，帮助认领更快通过审核，一次可最多上传5张图片
            </p>
            <p>
              2.图片需包含：歌手名、头像、平台logo信息，必须为jpg、png格式，图片大小
            </p>
          </div>
        </div>
      </div>

      <div class="tip" style="margin-top: 40px">填写邀请信息（选填）</div>
      <div class="row">
        <div class="left">
          <div class="label center-y">邀请码</div>
        </div>
        <div class="right">
          <input class="text" v-model="inviteCode" placeholder="（可以不填）" />
        </div>
      </div>

      <div class="row">
        <div class="left">
          <div class="label center-y"></div>
        </div>
        <div class="right">
          <div class="tip">
            <p>
              填写好友发出的邀请码，<span style="font-weight: bold"
                >若您成功入驻，您和好友都可获得5000酷豆</span
              >
            </p>
            <p>
              <span style="color: #000; font-weight: bold">如何邀请：</span>
            </p>
            <p>已入驻的音乐人-音乐人后台-任务中心-邀请音乐人入驻</p>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 50px">
        <div class="left">
          <div class="label center-y"></div>
        </div>
        <div class="right">
          <div class="tip">
            <p>
              <el-checkbox v-model="agreeChecked"
                >我已阅读<a
                  target="_blank"
                  href="https://www.kugou.com/imusic_dj/static/html/protocol.html"
                  style="color: #0090ff; text-decoration: underline"
                  >平台协议</a
                ></el-checkbox
              >
            </p>
          </div>
        </div>
      </div>

      <div class="row" style="margin-bottom: 60px">
        <div class="left">
          <div class="label center-y"></div>
        </div>
        <div class="right">
          <div class="btn submit" @click="submit">提交</div>
        </div>
      </div>
    </div>
    <div
      class="layout-right"
      v-show="(cardList.length != 0 && !claimFlag) || searchLoad"
    >
      <div class="search-load" v-show="searchLoad">
        <img src="../assets/img/searchLoad.gif" alt="" srcset="" />
      </div>
      <div class="title" v-show="cardList.length != 0">
        酷狗音乐已存在以下“{{ authorName }}”的音乐人账号，可点击直接认领
      </div>
      <div class="card-c" @scroll="singerScroll">
        <div v-for="(item, i) in cardList" :key="i">
          <img
            :src="
              replaceHttpsImg(item.Avatar) ||
              require('../assets/img/default.png')
            "
            alt
            @click="gotoSingerHome(item.AuthorId)"
          />
          <p class="name">{{ item.AuthorName }}</p>
          <div
            v-if="item.status == 1 || item.status == 2"
            class="btn btn-disabled"
          >
            已入驻
          </div>
          <div v-else class="btn" @click="claim(item)">立即认领</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import countryArray from "../data/country.json";
// import areaArray from "../data/area.json";
import { encryptPhone } from "../lib/utils";
import { uploadBase64Img } from "../lib/api";
import newUpload from "../lib/newUpload";
import RSA from "@kugou/kg-rsa";
import AES from "@kugou/kg-aes";
import replaceHttpsImg from "../lib/repalceHttpsImg";
import { checkName } from "../lib/sensitive"
import UploadImage from "@kugou/upload-image"
export default {
  created() {
    this.getBaseConfig();
  },
  mounted() {
    this.event();
    // this.checkSingerID()
    this.$nextTick(() => {
      this.myStatus();
    });
  },
  data() {
    return {
      authorNameChecked: true, //歌手名是否合法
      searchLoad: false,
      introPlaceholder:
        "个人简介（10-2000字），填写后将展示在歌手详细信息中，可参考以下内容：  \n个人信息：90后创作歌手  \n主要成就：腾讯音乐娱乐盛典最佳男/女歌手  \n代表作品：《***》",
      agreeChecked: false,
      typeArr: [],
      areaArr: [],
      countryArr: [],
      styleArr: [],
      identityArr: [],
      area: 0,
      identity: 4,
      country: 1,
      style: 3,
      type: 0,
      avatar: require("../assets/img/default.png"),
      searchPage: 1,
      searchTotalPage: 1,
      idCardPic: {
        1: {
          url: "",
          base64: "",
        },
        2: {
          url: "",
          base64: "",
        },
        3: {
          url: "",
          base64: "",
        },
      },
      inviteCode: "",
      code: "",
      idcard: "",
      realName: "",
      mobile: "",
      authorName: "",
      authorNameTimer: "",
      scrollTimer: "",
      codeFlag: false,
      codeCount: "60s",
      editHeadImg: require("../assets/img/default.png"),
      popupFlag: false,
      //1头像2歌手名3类型4地区5身份6简介
      popupType: "1",
      intro: "",
      option: {
        img: "", // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 10, // 默认生成截图框宽度
        // autoCropHeight: 10, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMove: false, //原图是否能拖动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      loading: false,
      cropper: false,
      checked: false,
      value: "",
      cardList: [],
      claimFlag: false,
      claimId: "",
      screenShot: [],
      id: 0,
      //简介表情flag
      introFlag_1: false,
      //简介敏感词flag
      introFlag_2: false,
      //简介字数flag
      introFlag_3: false,
    };
  },
  watch: {
    authorName() {
      this.searchPage = 1;
      this.cardList = [];
    },
  },
  methods: {
    //检测歌手名
    async checkName() {
      if(!await checkName(this.authorName)) {
        this.authorNameChecked = false
      } else {
         this.authorNameChecked = true
      }
    },
    //去歌手页
    gotoSingerHome(singerid) {
      window.open(`https://www.kugou.com/yy/singer/home/${singerid}.html`);
    },
    //失焦查空
    checkNull(key, msg) {
      console.log(key, this[key]);
      if (!this[key]) window.eventEmitter.emit("toast", msg);
    },
    //检测简介是否合法
    checkIntro() {
      //字数
      if (this.intro.length < 10 || this.intro.length > 2000) {
        this.introFlag_3 = true;
        return this.eventEmitter.emit("toast", "简介请输入10-2000字");
      } else {
        this.introFlag_3 = false;
      }
      //表情
      let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      if (iconRule2.test(this.intro)) {
        this.introFlag_1 = true;
        return this.eventEmitter.emit("toast", "请不要输入特殊字符");
      } else {
        this.introFlag_1 = false;
      }
      //敏感词
      this.api({
        apiName: "sensitive",
        postData: {
          word: this.intro,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.data.resultInfo) {
          this.introFlag_2 = res.data.data.resultInfo;
          return this.eventEmitter.emit("toast", res.data.data.resultInfo);
        } else {
          this.introFlag_2 = false;
        }
      });
    },
    //检测站外截图数量
    checkNum(e) {
      console.log(e);
      if (this.screenShot.length == 5) {
        window.eventEmitter.emit("toast", "一次可最多上传5张图片");
        e.preventDefault();
      }
    },
    //检测身份证
    checkIdcard() {
      if (
        !/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.idcard
        )
      ) return this.eventEmitter.emit("toast", "请输入正确的身份证格式");
      if (!this.idcard) return this.eventEmitter.emit("toast", "请输入身份证");
      this.api({
        apiName: "checkIdcard",
        methods: "GET",
        getData: {
          idno: this.idcard,
          typ: 1,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.status == 2) {
          this.idcard = "";
          //return this.eventEmitter.emit("toast", `该证件号已入驻，绑定酷狗id为：${res.data.lists[0]}，请用该id登陆`);
          return this.eventEmitter.emit("toast", `该身份证暂无法完成认证`);
        }
      });
    },
    //获取填写过的信息
    myStatus(cb) {
      this.api({
        apiName: "myStatus",
        methods: "GET",
        getData: {
          biz: "musician_author_dj",
        },
      }).then((res) => {
        const data = res.data.info;
        if (data) {
          this.user = data;
          this.avatar = data.avatar;
          this.editHeadImg = data.avatar;
          this.authorName = data.author_name;
          this.type = data.gender;
          this.area = data.area;
          this.identity = data.identity;
          this.intro = data.intro;
          this.style = data.genre;
          //this.idcard = data.idcard;
          this.realName = data.name;
          this.country = data.country;
          this.mobile = data.mobile;
          this.screenShot =
            JSON.stringify(data.external_screenshots) == "{}"
              ? []
              : data.external_screenshots;
          this.id = data.id || 0;
          this.inviteCode = data.invite_code;
          if (data.exists_author) {
            this.claimId = data.exists_author.author_id;
            this.claimFlag = true;
          }
          // this.idCardPic[1].url = data.idcard_pic1;
          // this.idCardPic[1].base64 = data.idcard_pic1;
          // this.idCardPic[2].url = data.idcard_pic2;
          // this.idCardPic[2].base64 = data.idcard_pic2;
          // this.idCardPic[3].url = data.idcard_pic3;
          // this.idCardPic[3].base64 = data.idcard_pic3;
        } else {
          this.checkSingerID();
        }
      });
    },
    //检查是否有绑定的歌手id
    checkSingerID() {
      this.api({
        apiName: "starStatus",
        postData: {
          userid: window.kugouid,
          token: window.token,
        },
      }).then((res) => {
        if (res.data.star_id != 0) {
          this.getSingerInfo(res.data.star_id);
        }
      });
    },
    //验证是否填写
    checkField() {
      const tipMap = {
        authorName: "请输入歌手名",
        avatar: "请上传头像",
        type: "请选择性别",
        area: "请选择地区",
        identity: "请选择身份",
        style: "请选择流派",
        intro: "请输入简介信息",
        idcard: "请输入身份证",
        realName: "请输入真实姓名",
        country: "请选择国籍",
        mobile: "请输入手机号",
        code: "请输入手机验证码",
        idCardPic: "请上传身份证明",
      };
      let msgArr = [];
      if(!this.authorNameChecked) msgArr.push("请输入合法歌手名");
      for (let i in tipMap) {
        //身份证明
        if (i == "idCardPic") {
          if (this.idCardPic[1].url == "") msgArr.push("请上传身份证正面图片");
          if (this.idCardPic[2].url == "") msgArr.push("请上传身份证反面图片");
          if (this.idCardPic[3].url == "") msgArr.push("请上传手持身份证图片");
        } else if (i == "avatar") {
          console.log(this.avatar);
          if (this.avatar.indexOf("base64") != -1) msgArr.push("请上传头像");
        } else if (i == "code") {
          if (!this.id && this.code.trim() == "") msgArr.push("请输入验证码");
        } else if (i == "idcard") {
          if (!this[i]) msgArr.push(tipMap[i]);
          if (
            !/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
              this.idcard
            )
          )
            msgArr.push("请输入正确的身份证格式");
        } else if (this[i] === "") {
          msgArr.push(tipMap[i]);
        }
      }
      if (msgArr.length != 0) {
        this.eventEmitter.emit("toast", {
          msg: msgArr.join("<br/>"),
          time: 3000
        });
        return false;
      }
      return true;
    },
    //提交
    submit() {
      //协议
      if (!this.agreeChecked)
        return this.eventEmitter.emit("toast", "请阅读平台协议，并同意");
      //简介
      if (this.introFlag_3)
        return this.eventEmitter.emit("toast", "简介请输入10-2000字");
      if (this.introFlag_1)
        return this.eventEmitter.emit("toast", "简介不要输入特殊字符");
      if (this.introFlag_2)
        return this.eventEmitter.emit("toast", `简介：${this.introFlag_2}`);
      if (!this.checkField()) return;

      //上报
      window.statisticInfo.BiStatistic = {
        appid: window.appid, //appId
        userid: window.kugouid, //用户id
        mid: window.mid, //mid
        a: 23296, //BI-a
        b: "点击", //BI-b
        ft: "音乐人入驻", //BI-ft
        r: "提交实名信息审核按钮", //BI-r
        'channel': 'WEB'
      };
      window.mobileLog(30050, window.statisticInfo.BiStatistic, null, 0);

      const data = {
        author_name: this.authorName,
        gender: this.type,
        idcard: this.idcard,
        country: this.country,
        area: this.area,
        mobile: this.mobile,
        name: this.realName,
        avatar: this.avatar,
        sms_code: this.code,
        genre: this.style,
        intro: this.intro,
        identity: this.identity,
        idcard_pic1: this.idCardPic[1].url,
        idcard_pic2: this.idCardPic[2].url,
        idcard_pic3: this.idCardPic[3].url,
        invite_code: this.inviteCode,
        exists_author_id: Number(this.claimId) || 0,
        external_screenshots: this.screenShot,
        id: this.id || 0,
        typ: 3,
      };
      console.log(data);
      this.api({
        apiName: "submitSettle",
        postData: data,
      })
        .then((res) => {
          console.log("submit", res);
          this.$router.push("/home");
        })
        .catch((err) => {
          this.eventEmitter.emit("toast", err.errmsg);
        });
    },
    //站外截图
    async screenUpload(dom) {
      let _t = this,
        el = dom.srcElement ? dom.srcElement : dom.target,
        file = el.files[0];
      if (el.files.length > 5 || _t.screenShot.length + el.files.length > 5)
        return _t.eventEmitter.emit("toast", "不能超过5张");
      for (let i of el.files) {
        if (i.size > 10 * 1024 * 1000)
          return window.eventEmitter.emit("toast", "请上传小于10M的图片");
      }
      if(el.files.length > 0){
        let uploadEx = new UploadImage({
          size: 10,
          appid: 1014,
          inputEle: false,
          log: true,
          openLoading: ()=>{
            console.log(111);
            window.eventEmitter.emit('loading', true)
          },
          hideLoading: ()=>{
            console.log(222);
            window.eventEmitter.emit('loading', false)
          },
          result: (res)=>{
            console.log('%c [ res ]-221', 'font-size:13px; background:pink; color:#bf2c9f;', res)
            res = res.filter(item=>{return item.status == 1})
            _t.screenShot = _t.screenShot.concat(
              res.map((item) => replaceHttpsImg(item.url))
            );
            console.log('[ _t.screenShot ] >', _t.screenShot)
          },
          fail: (err)=>{
            reject(err);
            window.eventEmitter.emit("toast", "网络错误，请稍后重试~");
          }
        });
        uploadEx.dealFiles(el.files);
      }
    },
    screenDel(i) {
      this.screenShot.splice(i, 1);
    },
    //选择框基础配置
    async getBaseConfig() {
      //接口500或返回数组null使用默认
      try {
        let res = await this.api({
          apiName: "baseConfig",
          methods: "GET",
          getData: {
            category: "1,2,3,4,5",
          },
        });
        if (res.errcode == 0) {
          const data = res.data.data;
          this.typeArr =
            data["1"].length != 0 ? data["1"] : [{ typeStr: "男", type: 0 }];
          this.areaArr =
            data["2"].length != 0 ? data["2"] : [{ typeStr: "内地", type: 0 }];
          this.identityArr =
            data["3"].length != 0 ? data["3"] : [{ typeStr: "制作", type: 4 }];
          this.styleArr =
            data["4"].length != 0 ? data["4"] : [{ typeStr: "电子", type: 3 }];
          this.countryArr =
            data["5"].length != 0
              ? data["5"]
              : [{ typeStr: "中国大陆", type: 1 }];
        } else {
          this.typeArr = [{ typeStr: "男", type: 0 }];
          this.areaArr = [{ typeStr: "内地", type: 0 }];
          this.identityArr = [{ typeStr: "制作", type: 4 }];
          this.styleArr = [{ typeStr: "电子", type: 3 }];
          this.countryArr = [{ typeStr: "中国大陆", type: 1 }];
        }
      } catch (error) {
        this.typeArr = [{ typeStr: "男", type: 0 }];
        this.areaArr = [{ typeStr: "内地", type: 0 }];
        this.identityArr = [{ typeStr: "制作", type: 4 }];
        this.styleArr = [{ typeStr: "电子", type: 3 }];
        this.countryArr = [{ typeStr: "中国大陆", type: 1 }];
      }
    },
    getSingerInfo(singerid) {
      this.api({
        apiName: "singerInfo",
        methods: "GET",
        getData: {
          singerid: singerid,
        },
      })
        .then((res) => {
          console.log("singerinfo", res);
          const data = res.data;
          this.claimFlag = true;
          this.claimId = singerid;
          this.authorName = data.name;
          this.identity = data.identity == -1 ? 0 : data.identity;
          this.type = data.gender == -1 ? 0 : data.gender;
          this.country = data.country == -1 ? 1 : data.country;
          this.area = data.area == -1 ? 0 : data.area;
          this.intro = data.intro;
          this.avatar = data.avatar
            ? replaceHttpsImg(data.avatar.replace("{size}", "240"))
            : require("../assets/img/default.png");
          this.editHeadImg = data.avatar
            ? replaceHttpsImg(data.avatar.replace("{size}", "240"))
            : require("../assets/img/default.png");
        })
        .catch((err) => {
          this.eventEmitter.emit("toast", err.errmsg || '服务器异常');
        });
    },
    claim(item) {
      if (item.status == 1) {
        return this.eventEmitter.emit("toast", "不能认领腾讯音乐人");
      } else if (item.status == 2) {
        return this.eventEmitter.emit("toast", "已入驻");
      } else if (item.status == 3) {
        if (item.kugouid != window.kugouid)
          return this.eventEmitter.emit(
            "toast",
            `该歌手已入驻，绑定酷狗id为：${item.kugouid}，请用该id登陆`
          );
      }

      this.getSingerInfo(item.AuthorId);
    },
    search(page, pageSize) {
      if(!this.authorName) return
      this.searchLoad = true;
      this.api({
        apiName: "singerSearch",
        methods: "GET",
        getData: {
          kugouid: window.kugouid,
          keyword: this.authorName,
          page: page || this.searchPage || 1,
          pagesize: pageSize || 18,
        },
      }).then((res) => {
        console.log("searc", res);
        this.searchLoad = false;
        this.searchPage++;
        this.searchTotalPage = res.data.total;
        if (JSON.stringify(res.data.lists) == "{}") res.data.lists = [];
        this.cardList = this.cardList.concat(res.data.lists);
      });
    },
    //500ms节流
    singerScroll(e) {
      //最后一页返回
      if (this.searchPage > this.searchTotalPage) return;

      let ele = e.srcElement ? e.srcElement : e.target;
      if (ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100) {
        //监听滚动到div底部
        this.scrollTimer && clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.search();
        }, 500);
      }
    },
    //500ms节流
    singerSearch() {
      if (!this.authorName) return;
      //清空从1开始
      this.searchPage = 1
      this.cardList = []
      this.authorNameTimer && clearTimeout(this.authorNameTimer);
      this.authorNameTimer = setTimeout(() => {
        this.search();
      }, 500);
    },
    getType(fileName) {
      let index = fileName.lastIndexOf(".");
      return fileName.slice(index + 1).toLowerCase();
    },
    /**
     * 上传图片
     */
    fileChange(dom, index) {
      console.log(dom);
      let _t = this,
        el = dom.srcElement ? dom.srcElement : dom.target,
        file = el.files[0];

      if (!file) {
        return;
      } else if (file.size > 10 * 1024 * 1000) {
        return this.eventEmitter.emit("toast", `请上传小于10M的图片`);
      }

      console.log(file);

      let fileReader = new FileReader();
      fileReader.onerror = function () {
        return this.eventEmitter.emit("toast", `上传失败，请稍后重试`);
      };
      fileReader.onload = function () {
        let result = this.result;
        let img = new Image();
        img.src = result;
        newUpload(
          {
            file: file,
            fileType: _t.getType(file.name),
            base64: result,
          },
          (base64, url) => {
            // const img = new Image();
            // img.src = base64;
            // el.parentNode.querySelector(".cover_item_content").innerHTML = "";
            // el.parentNode.querySelector(".cover_item_content").appendChild(img);

            console.log("url", url);
            _t.idCardPic[index] = {
              url: url,
              base64: base64,
            };
          },
          () => {
            //选择重复的触发onchange
            dom.value = null;
          }
        );
      };
      fileReader.readAsDataURL(file);
    },
    sendCode() {
      if (!this.mobile) return this.eventEmitter.emit("toast", "请输入手机号");
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        return this.eventEmitter.emit("toast", "请输入正确手机号");
      }
      const t = this;
      let source = {
        mobile: this.mobile,
        token: window.token,
      };
      const encryptedObj = AES.encrypt(JSON.stringify(source));
      const postData = {
        plat: 4,
        businessid: 8,
        mobile: encryptPhone(this.mobile),
        userid: window.kugouid,
        clienttime_ms: parseInt(new Date().getTime()),
        pk: RSA.encrypt(
          JSON.stringify({
            clienttime_ms: parseInt(new Date().getTime()),
            key: encryptedObj.key,
          })
        ),
        params: encryptedObj.encryptedStr,
      };
      console.log("postData", postData);
      let getData = {
        mid: window.mid,
        dfid: window.KgUser ? window.KgUser.getDfid() : '-'
      }
      console.log("getData", getData);
      this.api({
        apiName: "sendCode",
        postData: postData,
        getData: getData
      })
        .then((res) => {
          t.sendCodeCount();
        })
        .catch((err) => {
          t.eventEmitter.emit("toast", err.data || "服务器异常");
        });
    },
    sendCodeCount() {
      this.codeFlag = true;
      for (let i = 0; i <= 60; i++) {
        setTimeout(() => {
          this.codeCount = 60 - i + "s";
          if (i == 60) {
            this.codeFlag = false;
          }
        }, i * 1000);
      }
    },
    event() {
      document
        .getElementById("headUpload")
        .addEventListener("change", this.changeHeadImg);
    },
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    },
    changeHeadImg(e) {
      console.log("upload", e);
      const that = this;
      //判断宽高
      let url = window.URL || window.webkitURL;
      let img = new Image(); //手动创建一个Image对象
      img.src = url.createObjectURL(e.target.files[0]); //创建Image的对象的url
      img.onload = function () {
        console.log("height:" + this.height + "----width:" + this.width);
        if (this.height < 500 || this.width < 500) {
          that.clearHeadInput();
          return window.eventEmitter.emit("toast", "图片尺寸需要>500*500像素");
        } else if (e.target.files[0].size > 10 * 1024 * 1000) {
          //判断大小
          that.clearHeadInput();
          return window.eventEmitter.emit("toast", "图片大小不能超过10M");
        } else {
          that.getBase64(e.target.files[0], (res) => {
            that.option.img = res;
            that.cropper = true;
          });
        }
      };
    },
    autoClick() {
      document.getElementById("headUpload").click();
    },
    clearHeadInput() {
      document.getElementById("headUpload").value = "";
    },
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        this.getBase64(data, async (res) => {
          this.editHeadImg = res;
          let uploadRes = "";
          try {
            uploadRes = await uploadBase64Img(this.editHeadImg);
          } catch (err) {
            window.eventEmitter.emit("toast", err.error || "服务器异常");
          }
          console.log("uploadRes", uploadRes);
          if (uploadRes && uploadRes.status == 1) {
            this.avatar = this.replaceHttpsImg(uploadRes.url);
            this.editHeadImg = this.replaceHttpsImg(uploadRes.url);
          }
          this.cropper = false;
        });
      });
    },
    async edit() {
      if (this.popupType == 1) {
        console.log(this.editHeadImg);
        const uploadRes = await uploadBase64Img(this.editHeadImg);
        console.log("uploadRes", uploadRes);
        if (uploadRes && uploadRes.status == 1) {
          this.avatar = this.replaceHttpsImg(uploadRes.url);
          this.editHeadImg = this.replaceHttpsImg(uploadRes.url);
        }
      }
      this.popupFlag = false;
    },
    showPopup(type) {
      this.popupType = type;
      this.popupFlag = true;
    },
    closePopup() {
      this.popupFlag = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.enter {
  display: flex;
  width: 100%;
  height: calc(100vh - 5px);
  background: #fff;
  border-radius: 10px;
  overflow-y: auto;
  .popup-c {
    z-index: 1;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    .popup {
      position: absolute;
      width: 400px;
      height: auto;
      border: 1px solid #ccc;
      background-color: #fff;
      .header {
        height: 40px;
        line-height: 40px;
        background-color: #2c323b;
        font-size: 16px;
        color: #fff;
        position: relative;
        .title {
          margin-left: 15px;
        }
        .close {
          cursor: pointer;
          position: absolute;
          right: 15px;
          top: 10px;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
        }
      }
      .main {
        padding: 0 30px;
        background-color: #fff;
        .edit-radio {
          margin-top: 60px;
          text-align: center;
          .el-radio__label {
            font-size: 16px;
            color: #000;
          }
        }
        .edit-text {
          margin-top: 30px;
          input {
            width: calc(100% - 20px);
            height: auto;
            min-height: 35px;
            line-height: 35px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
        }
        .edit-textarea {
          margin-top: 30px;
          textarea {
            height: auto;
            min-height: 35px;
            line-height: 35px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
        }
        .edit-img {
          font-size: 16px;
          color: #888888;
          p:first-child {
            margin-top: 30px;
          }
          div {
            margin-top: 30px;
            text-align: center;
            img {
              width: 140px;
              height: 140px;
              border-radius: 10px;
            }
          }
        }
        .bottom {
          height: 120px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          > div {
            width: 130px;
            height: 40px;
            line-height: 40px;
            border-radius: 20px;
            text-align: center;
            cursor: pointer;
          }
          .left {
            color: #0090ff;
            border: 1px solid #0090ff;
          }
          .right {
            background-color: #0090ff;
            color: #fff;
          }
        }
      }
    }
  }
  .input-disabled {
    background: rgba(0, 0, 0, 0.1);
  }
  .layout-left {
    width: 628px;
    min-width: 628px;
    margin-left: 60px;
    .title {
      font-size: 24px;
      color: #000;
      margin: 60px 0 45px;
    }
    .tip {
      font-size: 18px;
      color: #888;
    }
    .row {
      position: relative;
      display: flex;
      margin-top: 20px;
      height: 40px;
      > div {
        position: relative;
        height: 100%;
      }
      .left {
        flex-basis: 100px;
        font-size: 16px;
        color: #000000;
        .label {
        }
      }
      .right {
        font-size: 16px;
        .el-select {
          width: 470px;
        }
        .radio {
          line-height: 40px;
        }
        .screen-upload {
          opacity: 0;
          position: absolute;
          width: 140px;
          height: 40px;
          cursor: pointer;
        }
        .screen-c {
          position: absolute;
          left: 180px;
          height: 50px;
          width: 600px;
          .img-c {
            margin-left: 30px;
            display: inline-block;
            position: relative;
            .img-del {
              position: absolute;
              width: 16px;
              height: 16px;
              right: -20px;
              top: 0;
              line-height: 16px;
              font-size: 12px;
              text-align: center;
              background: rgba(0, 0, 0, 0.1);
              color: #fff;
              border-radius: 8px;
              cursor: pointer;
            }
            img {
              max-height: 50px;
              width: auto;
              height: auto;
              max-width: 80px;
            }
          }
        }
        .upload-idcard {
          width: 100%;
          position: relative;
          overflow: hidden;
          .cover_item {
            position: relative;
            float: left;
            width: 199px;
            height: 220px;
            overflow: hidden;
            -webkit-border-radius: 6px;
            border-radius: 6px;
            margin: 0 0 0 15px;
            &:first-child {
              margin-left: 0;
            }
            input {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 48px;
              opacity: 0;
              cursor: pointer;
              padding: 0;
              border: 0;
            }
            a {
              display: block;
              width: 100%;
              height: 48px;
              color: #fff;
              font-size: 16px;
              line-height: 48px;
              text-align: center;
            }
            .blue_btn {
              display: inline-block;
              color: #fff;
              background: #0090ff;
              -webkit-border-radius: 2px;
              border-radius: 2px;
            }
            .cover_item_content {
              position: relative;
              height: 170px;
              background: #f8f8f8;
              overflow: hidden;

              img {
                position: absolute;
                max-width: 100%;
                top: 50%;
                left: 50%;
                -webkit-transform: translate(-50%, -50%);
                -ms-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
              }

              p {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                text-align: center;
                font-size: 15px;
                color: #666;
                line-height: 45px;
              }
              .icon {
                display: inline-block;
                background-image: url(../assets/img/sprite.png);
              }
              .icon_id {
                background-position: -770px 0;
                width: 164px;
                height: 102px;
              }
              .icon_id_back {
                background-position: -939px 0;
                width: 165px;
                height: 102px;
              }
              .icon_id_handle {
                background-position: -1284px 0;
                width: 173px;
                height: 105px;
              }
              i {
                position: absolute;
                top: 50%;
                left: 50%;
                -webkit-transform: translate(-50%, -62%);
                -ms-transform: translate(-50%, -62%);
                transform: translate(-50%, -62%);
              }
            }
          }
        }
        .code-btn,
        .code-time {
          float: right;
          width: 120px;
          margin-left: 10px;
          text-align: center;
          height: 40px;
          line-height: 40px;
          background-color: #0090ff;
          color: #fff;
        }
        .code-btn {
          cursor: pointer;
        }
        .code-time {
          background-color: #888;
        }
        .tip {
          p {
            font-size: 14px;
            color: #888888;
          }
        }
        .head-img {
          position: relative;
          p {
            width: 190px;
            line-height: 1.5;
            font-size: 14px;
            color: #888888;
            position: absolute;
            top: 25px;
            left: 100px;
          }
          img {
            width: 90px;
            height: 90px;
          }
          .btn {
            position: absolute;
            width: 90px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #0090ff;
            color: #fff;
            right: 20px;
            top: 50%;
            margin-top: -15px;
            cursor: pointer;
          }
        }
        .text {
          width: 450px;
          height: auto;
          min-height: 38px;
          line-height: 38px;
          padding: 0 10px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          font-size: 16px;
        }
        .textarea {
          width: 470px;
        }
        textarea {
          height: auto;
          min-height: 35px;
          line-height: 35px;
          padding: 0 10px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          font-size: 16px;
        }
        .btn {
          float: right;
          width: 140px;
          height: 40px;
          font-size: 16px;
          text-align: center;
          line-height: 40px;
          border-radius: 20px;
          cursor: pointer;
          position: relative;
        }
        .submit {
          background-color: #0090ff;
          color: #fff;
          margin-right: 20px;
        }
        .back {
          border: 1px solid rgba(0, 0, 0, 0.1);
          color: #000;
        }
      }
    }
  }
  .layout-right {
    //flex-grow: 1;
    flex-basis: 500px;
    min-width: 500px;
    position: relative;
    .search-load {
      position: absolute;
      width: 100%;
      height: 670px;
      top: 130px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
    }
    .title {
      font-size: 16px;
      color: #000;
      margin-top: 130px;
      text-align: center;
    }
    .card-c {
      position: relative;
      width: 100%;
      height: auto;
      max-height: 640px;
      overflow-y: auto;
      display: flex;
      justify-content: flex-start;
      margin-top: 30px;
      flex-wrap: wrap;
      > div {
        width: 148px;
        height: 200px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        text-align: center;
        border-radius: 10px;
        margin-top: 10px;
        margin-right: 10px;
        img {
          width: 80px;
          height: 80px;
          border-radius: 40px;
          margin-top: 18px;
          cursor: pointer;
        }
        .name {
          margin-top: 15px;
          font-size: 18px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .btn {
          margin: 15px auto 0;
          width: 98px;
          height: 28px;
          border: 1px solid #0090ff;
          color: #0090ff;
          border-radius: 15px;
          line-height: 28px;
          text-align: center;
          cursor: pointer;
          font-size: 14px;
        }
        .btn-disabled {
          background-color: rgba(0, 0, 0, 0.1);
          border: none;
          color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Enter.vue